import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaUser, FaCog } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import './BottomNavigation.css';

const BottomNavigation = () => {
  const location = useLocation();
  const { isAuthenticated, isAdmin, user } = useAuth();
  
  // Отладочная информация для проверки статуса администратора
  console.log('BottomNavigation - User:', user);
  console.log('BottomNavigation - isAdmin:', isAdmin);
  
  // Проверяем, активна ли ссылка
  const isActive = (path) => location.pathname === path;
  
  return (
    <div className="bottom-navigation">
      <Link 
        to="/" 
        className={`nav-item ${isActive('/') ? 'active' : ''}`}
      >
        <FaHome className="nav-icon" />
      </Link>
      
      {isAuthenticated && (
        <Link 
          to="/profile" 
          className={`nav-item ${isActive('/profile') ? 'active' : ''}`}
        >
          <FaUser className="nav-icon" />
        </Link>
      )}
      
      {isAdmin && (
        <Link 
          to="/admin" 
          className={`nav-item ${isActive('/admin') ? 'active' : ''}`}
        >
          <FaCog className="nav-icon" />
        </Link>
      )}
    </div>
  );
};

export default BottomNavigation;
